import { ISearchFilter } from '@hooks/useFilteredSearch';
import {
  GetDocumentsByStudioFilter,
  GetDocumentsByStudioParams,
} from '@services/queries/documents/getDocumentsByStudio/getDocumentsByStudio.types';

export function makeGetDocumentsByStudioParams(
  studioId: string,
  pageParam: number,
  pageFilter: ISearchFilter<GetDocumentsByStudioFilter>,
): GetDocumentsByStudioParams {
  return {
    studioId,
    page: pageParam,
    q: pageFilter.q,
    ...pageFilter.pagination,
    ...pageFilter.filter,
    ...pageFilter.sort,
  };
}
